const apiProtocall = 'https';
const apiTimeOut = 10000;

const constantparameters = {

    // Environment name is set via REACT_APP_ENV_NAME env var at build time.
    // API URL uses relative paths in deployed environments (same origin),
    // and localhost for local dev.
    environmentName: process.env.REACT_APP_ENV_NAME || "",
    apiUrlWithPort: typeof process.env.REACT_APP_API_URL !== 'undefined' ? process.env.REACT_APP_API_URL : `https://localhost:5001`,
};

module.exports = constantparameters;